// Auto-generated by scripts/write-build-version.js
export const BUILD_VERSION = "0.1.0-4226a03-1793828408436";
export const BUILD_LABEL = "0.1.0 (4226a03)";
export const BUILD_TIME = "2026-11-04T21:40:08.436Z";
